/*

      Flash detector v0.5
      By Eric Gerds   http://www.pinlady.net/PluginDetect/

 Note:
  1) In your web page, load the PluginDetect script BEFORE you load this script.
  2) In your web page, have the output <div> BEFORE this script. The <div> looks like this:
       <div id="detectFlash_output"></div>
  3) Feel free to modify this script as you wish.
  4) If you wish to use the plugindetect <div>, then insert it into the <body>,
     anywhere BEFORE the plugin detection begins.
     This <div> temporarily holds any plugin object that is inserted into the web page,
     but only when needed for detection.
     For example:
        <div id="plugindetect" style="right:0px; top:0px; position:absolute;"></div>
     This step is optional, as PluginDetect will create and insert the <div> automatically 
     when needed.


*/


(function(){


 // Return text message based on plugin detection result
 var getStatusMsg = function(obj){
   if (obj.status==1) return "installed & enabled, version is >= " + obj.minVersion;
   if (obj.status==0) return "installed & enabled, version is unknown";
   if (obj.status==-0.1) return "installed & enabled, version is < " + obj.minVersion;
   if (obj.status==-0.2) return "installed but not enabled";
   if (obj.status==-1) return "not installed or not enabled";
   if (obj.status==-3) return "error...bad input argument to PluginDetect method";
   return "unknown";
 };   // end of function

 var out = document.getElementById("detectFlash_output");  // node for output text

 // Add text to output node
 var docWrite = function(text){
     if (out){
        if (text){
          text = text.replace(/&nbsp;/g,"\u00a0");
          out.appendChild(document.createTextNode(text));
        };
        out.appendChild(document.createElement("br"));
     };
 };  // end of function


   // Object that holds all data on the plugin
   var P = {name:"Flash", status:-1, version:null, minVersion:"19,0,0,0"};


   var $=PluginDetect,
   
   // The 'instantiate' input argument only affects non-Internet Explorer browsers.
   // 
   // When 'instantiate' is undefined or false, then PluginDetect will detect
   // the plugin by searching the navigator.plugins[] array. This method of detection
   // may only reveal the first 3 digits of the plugin version, although it may sometimes
   // reveal all 4 digits.
   // There should not be any security popup messages generated by any browsers
   // during this plugin detection.
   //
   // When 'instantiate' is true, then an instance of the plugin will be inserted into
   // the DOM. This may cause a security popup message to appear in some browsers 
   // asking for permission to run the plugin (if the plugin is outdated or insecure).
   // If or when the plugin runs, then this plugin instance will be queried by
   // PluginDetect to get all 4 digits of the plugin version. 
   //
   // The plugin version that is revealed for instantiate=true is more reliable than
   // the plugin version that is revealed for instantiate=false.
   //
   // Note: For Internet Explorer, all 4 digits of plugin version will always be revealed, 
   // regardless of the value of 'instantiate'.
   instantiate=false;


   if ($.getVersion)
   {
      P.version = $.getVersion(P.name, instantiate);
      docWrite("Plugin version: " + P.version);
   };


   if ($.isMinVersion){
      P.status = $.isMinVersion(P.name, P.minVersion, instantiate);
      docWrite("Plugin status: " + getStatusMsg(P));
   };


   if ($.getInfo)
   {
      // Get extra plugin info
      var INFO = $.getInfo(P.name);

      if (INFO)
      {
         var precision = INFO.precision; // 0 - 4
         precision = (["Major", "Minor", "Revision", "Build"].slice(0, precision)).concat(["0", "0", "0", "0"].slice(0,4-precision)).join();
         docWrite("Detected version precision: " + precision);
         
         docWrite("Flash plugin has been activated by PluginDetect: " + (INFO.flashObjUsed ? true : false));

         docWrite("");

         // The 'instantiate' input argument only applies to non-IE browsers
         if (!$.browser.isIE && !INFO.flashObjUsed && INFO.precision && INFO.precision < 4)
         {
             docWrite("Note: some browsers will allow you to obtain all 4 digits of the plugin version if you set the " +
                 "'instantiate' input argument to 'true'.");
             docWrite("You will also have to give your browser permission to run the plugin.");

         };

      }

   }


   if ($.browser.isIE)
   {
      docWrite("");
      docWrite("ActiveX enabled / ActiveX scripting enabled: " +
        ($.browser.ActiveXEnabled ? "true" : "false [this may prevent the plugin from running in Internet Explorer]")
      );
      docWrite("ActiveX Filtering enabled: " +
        ($.browser.ActiveXFilteringEnabled ? "true [this may prevent the plugin from running in Internet Explorer]" : "false")
      );
   };


})();   // end of function


